import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

const menuFilterProps = {
  visible: Boolean,
};

export type MenuFilterProps = {
  visible: boolean;
};

export const FilterInput = styled.div`
  border-bottom: 1px solid ${theme.colors.gray3};
  margin-bottom: ${theme.spacings.medium};
  padding-bottom: ${theme.spacings.medium};

  & input {
    width: 100%;
  }
`;

export const FilterButtons = styled.div`
  align-items: center;
  border-top: 1px solid ${theme.colors.gray3};
  display: flex;
  gap: ${theme.spacings.medium};
  justify-content: flex-end;
  margin-top: ${theme.spacings.medium};
  padding-top: ${theme.spacings.medium};
`;

export const FilterList = styled.div`
  display: grid;
  gap: ${theme.spacings.medium};
  max-height: 245px;
  overflow: auto;

  &.hasInput {
    /* border-top: 1px solid ${theme.colors.gray3}; */
    /* padding-top: ${theme.spacings.medium}; */
  }
`;

export const LabelCount = styled.div`
  margin-top: ${theme.spacings.medium};
  text-align: right;

  & > label {
    font-size: ${theme.font.sizes.p3};
    line-height: ${theme.font.lineHeights.p3};

    &.bold {
      color: ${theme.colors.primary};
      font-weight: ${theme.font.bold};
    }
  }
`;

export const Wrapper = styled('div', menuFilterProps)`
  ${({ visible }: MenuFilterProps) => css`
    height: auto;
    position: absolute;
    z-index: ${theme.layers.overlay};

    ${!visible && 'display: none'}
  `}
`;
